import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Save, ExternalLink } from "lucide-react";
import { Panel } from "../ui-kit";
import { VIP_DEFAULT } from "../../lib/vipDefaults";

const inp = "w-full bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white focus:border-gold focus:outline-none";

function ServiceEdit({ s, i, set, remove }) {
  return (
    <div className="border border-[color:var(--border-subtle)] p-3 space-y-2" data-testid={`vip-edit-service-${i}`}>
      <div className="flex gap-2">
        <input className={inp} value={s.t} maxLength={60} placeholder="Service naam" onChange={(e) => set({ ...s, t: e.target.value })} data-testid={`vip-edit-service-${i}-name`} />
        <input className={inp} value={s.tag} maxLength={60} placeholder="Tag" onChange={(e) => set({ ...s, tag: e.target.value })} data-testid={`vip-edit-service-${i}-tag`} />
        <button onClick={remove} className="px-2 text-slate-500 hover:text-bear" data-testid={`vip-edit-service-${i}-remove`}><Trash2 size={16} /></button>
      </div>
      <textarea className={`${inp} min-h-[90px]`} value={s.pts.join("\n")} placeholder="Har line ek point"
        onChange={(e) => set({ ...s, pts: e.target.value.split("\n").slice(0, 10).map((p) => p.slice(0, 200)) })} data-testid={`vip-edit-service-${i}-points`} />
    </div>
  );
}

export function VipPageEditor() {
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    client.get("/public/join-config").then(({ data }) => live && setV((cur) => cur || data.vip_page || VIP_DEFAULT)).catch(() => live && setV((cur) => cur || VIP_DEFAULT));
    return () => { live = false; };
  }, []);
  if (!v) return null;
  const setSvc = (i, s) => setV({ ...v, services: v.services.map((x, j) => (j === i ? s : x)) });
  const save = async () => {
    setBusy(true);
    const body = { ...v, services: v.services.map((s) => ({ ...s, pts: s.pts.map((p) => p.trim()).filter(Boolean) })) };
    try { await client.patch("/settings", { vip_page: body }); toast.success("VIP page saved"); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <Panel title="VIP Page (/vip)" className="lg:col-span-2" testid="vip-page-editor">
      <div className="p-4 space-y-3">
        <div className="grid sm:grid-cols-2 gap-2">
          <input className={inp} value={v.title} maxLength={80} placeholder="Heading" onChange={(e) => setV({ ...v, title: e.target.value })} data-testid="vip-edit-title" />
          <input className={inp} value={v.subtitle} maxLength={80} placeholder="Gold line" onChange={(e) => setV({ ...v, subtitle: e.target.value })} data-testid="vip-edit-subtitle" />
        </div>
        <textarea className={`${inp} min-h-[70px]`} value={v.intro} maxLength={600} placeholder="Intro text" onChange={(e) => setV({ ...v, intro: e.target.value })} data-testid="vip-edit-intro" />
        <div className="grid lg:grid-cols-2 gap-2">
          {v.services.map((s, i) => <ServiceEdit key={i} s={s} i={i} set={(x) => setSvc(i, x)} remove={() => setV({ ...v, services: v.services.filter((_, j) => j !== i) })} />)}
        </div>
        <div className="flex flex-wrap gap-2">
          {v.services.length < 6 && <button onClick={() => setV({ ...v, services: [...v.services, { t: "New Service", tag: "", pts: [] }] })} className="px-3 py-2 text-xs border border-[color:var(--border-subtle)] text-slate-300 hover:border-gold flex items-center gap-1" data-testid="vip-edit-add-service"><Plus size={14} />Service add karein</button>}
          <button onClick={save} disabled={busy || !v.title.trim() || v.services.some((s) => !s.t.trim())} className="btn-gold px-4 py-2 text-xs flex items-center gap-1 disabled:opacity-50" data-testid="vip-edit-save"><Save size={14} />Save VIP page</button>
          <a href="/vip" target="_blank" rel="noreferrer" className="px-3 py-2 text-xs text-gold flex items-center gap-1 hover:underline" data-testid="vip-edit-preview"><ExternalLink size={14} />Page dekhein</a>
        </div>
      </div>
    </Panel>
  );
}
